module.exports = __webpack_public_path__ + "static/img/8.8219d75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/set/4/8.jpg
// module id = Vb79
// module chunks = 0